'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ClerkProvider } from '@clerk/nextjs';
import { ConsentUpgradeReload } from '@extern/consent/consent-upgrade-reload';
import { SonnerToaster } from '@extern/ui/sonner';
import { TooltipProvider } from '@extern/ui/tooltip';
import { usePathname } from 'next/navigation';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { ReactQueryProvider } from '@/infra/react-query/react-query-provider';
import { PageView } from '@/lib/analytics/page-view';
import { PostHogProvider } from '@/lib/analytics/posthog-provider';
import { allowsThirdPartyTracking } from '@/lib/analytics/third-party-tracking-routes';
import { CookiebotScript } from './cookiebot-script';
import { SegmentScript } from './segment-script';
import { TikTokPixelScript } from './tik-tok-pixel-script';
interface AppProvidersProps {
  children?: ReactNode;
}
export function AppProviders(t0) {
  const $ = _c(18);
  const {
    children
  } = t0;
  const t1 = usePathname();
  let t2;
  if ($[0] !== t1) {
    t2 = allowsThirdPartyTracking(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const thirdPartyTracking = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SonnerToaster />;
    t4 = <PageView />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <ReactQueryProvider><NuqsAdapter><TooltipProvider>{children}{t3}{t4}</TooltipProvider></NuqsAdapter></ReactQueryProvider>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5 || $[7] !== thirdPartyTracking) {
    t6 = <ClerkProvider><PostHogProvider surveys={thirdPartyTracking}>{t5}</PostHogProvider></ClerkProvider>;
    $[6] = t5;
    $[7] = thirdPartyTracking;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CookiebotScript />;
    t8 = <ConsentUpgradeReload />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  let t10;
  let t9;
  if ($[11] !== thirdPartyTracking) {
    t9 = <SegmentScript appcues={thirdPartyTracking} />;
    t10 = thirdPartyTracking ? <TikTokPixelScript /> : null;
    $[11] = thirdPartyTracking;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6 || $[16] !== t9) {
    t11 = <>{t6}{t7}{t8}{t9}{t10}</>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}